class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!document.querySelector(".section-header")) return;
    this.header = document.querySelector(".section-header");
    this.announcementBar = document.querySelector(".announcement-header");
    this.headerIsAlwaysSticky =
      this.getAttribute("data-sticky-type") === "always" ||
      this.getAttribute("data-sticky-type") === "reduce-logo-size";
    this.headerBounds = {};

    this.setHeaderHeight();

    window
      .matchMedia("(max-width: 990px)")
      .addEventListener("change", this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add("shopify-section-header-sticky");
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);
    window.addEventListener("resize", debounce(this.onResize.bind(this), 250));

    this.createObserver();
  }

  setHeaderHeight() {
    if (this.header)
      document.documentElement.style.setProperty(
        "--header-height",
        `${this.header.offsetHeight}px`,
      );
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      `${
        this.announcementBar != null ? this.announcementBar.offsetHeight : 0
      }px`,
    );
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > 10) {
      this.header.classList.add("scrolled-past-header");
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > 10) {
      this.header.classList.add("scrolled-past-header");
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove("scrolled-past-header");
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (!this.header && this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
    );
    this.closeMenuDisclosure();
    //this.closeSearchModal();
  }

  reveal() {
    if (!this.header && this.headerIsAlwaysSticky) return;
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.classList.remove("shopify-section-header-hidden");
  }

  reset() {
    if (!this.header && this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate",
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll("header-menu");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector("details-modal");
    this.searchModal.close(false);
  }

  onResize = () => {
    this.setHeaderHeight();
  };
}

customElements.define("sticky-header", StickyHeader);

class InView extends HTMLElement {
  constructor() {
    super();
    new Waypoint({
      element: this,
      handler: () => {
        this.classList.add("in-view");
      },
      offset: "70%",
    });
  }
}

customElements.define("in-view", InView);

class NavScroll extends HTMLElement {
  constructor() {
    super();
    this.offsetEL = this.querySelector(".list-collections__collection-offset");
    this.sections = document.querySelectorAll(".list-collections__collection");
    this.navItems = document.querySelectorAll(".list-collections__nav-link");
    this.navItem = document.querySelector(
      `.list-collections__nav-link[href="#${this.dataset.nav}"]`,
    );
    this.navList = document.querySelector(".list-collections__nav");
    this.navItem.addEventListener("click", (e) => {
      e.preventDefault();
      this.navItems.forEach((item) => {
        item.classList.remove("active");
      });
      this.navItem.classList.add("active");
      let offset = -180;
      if (window.matchMedia("(max-width: 765px)").matches) {
        offset = -180;
      }
      scrollToElem(this, offset);
      return false;
    });
    document.addEventListener("scroll", (event) => this.onScroll(event));
  }

  onScroll(e) {
    var elxx = this.offsetEL.offsetTop - 100;
    var top_of_screenxx = document.documentElement.scrollTop;

    this.navList.style.top =
      document.querySelector(".header-wrapper").offsetHeight - 2 + "px";

    if (top_of_screenxx > elxx) {
      this.sections.forEach((section) => {
        section.classList.remove("active");
      });
      this.classList.add("active");
      if (!this.navItem.classList.contains("active")) {
        this.navItems.forEach((item) => {
          item.classList.remove("active");
        });
        this.navItem.classList.add("active");
        const containerCenter = this.navList.offsetWidth / 2;
        const itemCenter =
          this.navItem.offsetLeft + this.navItem.offsetWidth / 2;
        this.navList.scrollLeft = itemCenter - containerCenter;
      }
    }
  }
}

customElements.define("nav-scroll", NavScroll);

class OctaineQuiz extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector(`form`);
    this.init();
  }

  init() {
    document.addEventListener(
      "octane.quiz.addToCart",
      (e) => {
        this.selectOptionByVariantId(e.detail.items[0].id);
      },
      false,
    );
  }

  selectOptionByVariantId(variantId) {
    const data = JSON.parse(
      document.getElementById(`json-${this.dataset.productId}`).textContent,
    );

    const variant = data.find((variant) => variant.id == variantId);
    if (typeof variant !== "undefined") {
      const variantRadios = this.querySelector(
        `.js-variants[data-product-id='${this.dataset.productId}']`,
      );

      if (
        variantRadios.querySelector(
          `[type="radio"][value="${variant.options[0]}"]`,
        )
      )
        variantRadios
          .querySelector(`[type="radio"][value="${variant.options[0]}"]`)
          .click();

      if (
        variantRadios.querySelector(
          `[type="radio"][value="${variant.options[1]}"]`,
        )
      )
        variantRadios
          .querySelector(`[type="radio"][value="${variant.options[1]}"]`)
          .click();

      // This is the multiple product layout in LP
      if (
        document.querySelector(
          `[type="radio"][data-product-id="${this.dataset.productId}"]`,
        )
      ) {
        document
          .querySelector(
            `[type="radio"][data-product-id="${this.dataset.productId}"]`,
          )
          .click();
      }
    }
  }
}

customElements.define("octaine-quiz", OctaineQuiz);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.navItems = this.querySelectorAll("[data-nav-index]");
    if (!this.slider || typeof $.fn.slick === "undefined") {
      console.warn("No slider found");
      return;
    }

    this.inview = this.dataset.inView === "true";
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.slider);

    this.init();
  }

  applyA11yLabels() {
    const slickTrack = this.slider.querySelector(
      '.slick-track[role="listbox"]',
    );
    const label = this.dataset.sliderLabel || "Slider items";
    if (slickTrack) {
      slickTrack.setAttribute("aria-label", label);
    }
  }

  init() {
    if ($(this.slider).not(".slick-initialized").length) {
      const config = JSON.parse(this.getAttribute("data-slider-config"));
      $(this.slider).slick(config);

      this.applyA11yLabels();

      if (this.inview) {
        $(this.slider).slick("slickPause");
      }

      $(this.slider).on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          if (
            slick.$slides[currentSlide].querySelector("deferred-media") != null
          )
            slick.$slides[currentSlide].querySelector("deferred-media").stop();
          if (slick.$slides[nextSlide].querySelector("deferred-media") != null)
            slick.$slides[nextSlide].querySelector("deferred-media").play();
        },
      );

      $(this.slider).on("init reInit setPosition afterChange", () => {
        this.applyA11yLabels();
      });

      if (this.inview) {
        new Waypoint.Inview({
          element: this,
          enter: () => $(this.slider).slick("slickPlay"),
          exited: () => $(this.slider).slick("slickPause"),
        });
      }
    }
  }

  rebuild() {
    $(this.slider)?.slick("setPosition");
    this.applyA11yLabels();
  }

  goToSlide(index) {
    $(this.slider).slick("slickGoTo", index);
  }

  setPosition() {
    $(this.slider).slick("reinit");
    this.applyA11yLabels();
  }
}
customElements.define("slider-component", SliderComponent);

class Accordion extends HTMLElement {
  constructor() {
    super();
  }

  reset() {
    const tabs = this.querySelectorAll("accordion-tab");
    tabs.forEach((tab) => {
      tab.collapse();
    });
  }
}
customElements.define("accordion-group", Accordion);

class AccordionTab extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button") || this.querySelector("a");

    if (!button) return;
    button.addEventListener("click", () => {
      const accordionGroup = this.parentElement.closest("accordion-group");
      if (this.hasAttribute("open")) {
        if (accordionGroup) accordionGroup.reset();
        else this.collapse();
      } else {
        if (accordionGroup) accordionGroup.reset();
        this.expand();
      }
    });
  }

  expand() {
    this.setAttribute("open", "");
  }

  collapse() {
    this.removeAttribute("open");
  }
}
customElements.define("accordion-tab", AccordionTab);

class AccordionOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button") || this.querySelector("a");

    if (!button) return;
    button.addEventListener("click", () => {
      const accordion = document.querySelector(
        this.getAttribute("data-accordion"),
      );

      if (accordion) {
        if (accordion.hasAttribute("open")) {
          accordion.collapse();
        } else {
          accordion.parentElement.reset();
          accordion.expand();
        }
      }
    });
  }

  reset() {
    this.removeAttribute("open");
  }
}
customElements.define("accordion-opener", AccordionOpener);

class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector(".ps-accordion-new");
    this.details = this.querySelector("details");
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this);
    this.init();
  }
  init() {
    if (this.getAttribute("openDesktop") != null && this.clientWidth > 768) {
      this.details.setAttribute("open", true);
    }
  }
}
customElements.define("accordion-component", AccordionComponent);

class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    if (typeof Vimeo !== "undefined") {
      this.iframe = document.querySelector("iframe");
      this.player = new Vimeo.Player(this.iframe);
      this.thumbnail = this.querySelector(".thumbnail");

      this.thumbnail.addEventListener("click", () => {
        this.thumbnail.classList.add("hidden");
        this.player.play();
      });
    }
  }
}

customElements.define("video-player", VideoPlayer);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (this.querySelector("template").content.firstElementChild) {
      if (!poster) {
        this.loadContent(this.dataset.focus === "true");
        return;
      }
      poster.addEventListener("click", this.loadContent.bind(this));
    }
  }

  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();

      if (deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }

      if (this.dataset.playMode == "inview") {
        new Waypoint.Inview({
          element: this,
          enter: () => {
            if (this.dataset.inSlider == "true") {
              if (this.closest(".slick-current.slick-active")) {
                this.play();
              }
            } else {
              this.play();
            }
          },
          exit: () => this.stop(),
        });
      }
    }
  }

  stop() {
    this.querySelector("video, model-viewer, iframe").pause();
  }

  play() {
    this.querySelector("video, model-viewer, iframe").play();
  }

  toggle() {
    if (this.querySelector("video, model-viewer, iframe").paused) {
      this.play();
    } else {
      this.stop();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(".close-button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );

    this.querySelectorAll(".drawer-overlay-close").forEach((button) =>
      button.addEventListener("click", this.onCloseOverlayClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });

    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  onCloseOverlayClick(event) {
    const detailsElement = event.currentTarget.parentElement;
    this.closeMenuDrawer(event, detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    document.body.classList.remove(`overflow-hidden`);
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.openDrawerBtn = document.querySelector(
      `.open__drawer[href='#${this.mainDetailsToggle.id}']`,
    );

    if (this.openDrawerBtn) {
      this.openDrawerBtn.addEventListener("click", (e) => {
        e.preventDefault();

        this.querySelector("summary").click();
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");

    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {};
}

customElements.define("header-drawer", HeaderDrawer);

class SearchDrawer extends HeaderDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    super.openMenuDrawer(summaryElement);

    // Focus the search input when the drawer opens
    const searchInput = this.querySelector(".search__input");
    console.log(searchInput);
    if (searchInput) {
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    }
  }
}

customElements.define("search-drawer", SearchDrawer);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChangeHandler = this.onVariantChange.bind(this);
    this.onExternalVariantSyncHandler = this.onExternalVariantSync.bind(this);
    this.isSyncingFromExternal = false;

    this.addEventListener("change", this.onVariantChangeHandler);
  }

  connectedCallback() {
    document.addEventListener(
      "variant-picker:sync",
      this.onExternalVariantSyncHandler,
    );
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onVariantChangeHandler);
    document.removeEventListener(
      "variant-picker:sync",
      this.onExternalVariantSyncHandler,
    );
  }

  onVariantChange(e) {
    this.updateOptions();
    this.setCurrentVariant();
    this.toggleAddButton(true, true, false);
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
    } else {
      if (this.currentVariant.available)
        this.toggleAddButton(false, true, true);
      this.updateURL();

      if (this.dataset.updateInfo === "true") {
        this.renderProductInfo(e.target);
        this.updateMedia();
      }

      this.updateVariantInput(e);
      this.syncLinkedVariantPickers();
      // this.updateOptionLabel();
    }
  }

  syncLinkedVariantPickers() {
    if (this.isSyncingFromExternal || !this.currentVariant) return;

    document.dispatchEvent(
      new CustomEvent("variant-picker:sync", {
        detail: {
          productId: String(this.dataset.productId || ""),
          section: String(this.dataset.section || ""),
          variantId: String(this.currentVariant.id),
        },
      }),
    );
  }

  onExternalVariantSync(event) {
    const detail = event.detail || {};

    if (!detail.productId || !detail.variantId) return;
    if (String(this.dataset.productId || "") !== String(detail.productId))
      return;
    if (String(this.dataset.section || "") === String(detail.section || ""))
      return;

    const variant = this.getVariantData().find((item) => {
      return String(item.id) === String(detail.variantId);
    });

    if (!variant) return;

    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    let changedInput = null;

    fieldsets.forEach((fieldset, index) => {
      const optionValue = variant.options[index];
      if (typeof optionValue === "undefined") return;

      const optionInput = Array.from(
        fieldset.querySelectorAll('input[type="radio"]'),
      ).find((input) => input.value === optionValue);

      if (optionInput && !optionInput.checked) {
        optionInput.checked = true;
        changedInput = optionInput;
      }
    });

    if (!changedInput) return;

    this.isSyncingFromExternal = true;
    this.onVariantChange({
      target: changedInput,
      currentTarget: this,
    });
    this.isSyncingFromExternal = false;
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  // updateOptionLabel() {
  //   const optionLabel = this.querySelector('.form__label');
  //   if (optionLabel) {
  //       optionLabel.innerHTML = this.currentVariant.title;
  //   }
  // }

  setCurrentVariant() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    let metafields = {};

    if (
      this.querySelector(
        `[id="json-${this.dataset.productId}-variants-metafields"]`,
      )
    ) {
      metafields = JSON.parse(
        this.querySelector(
          `[id="json-${this.dataset.productId}-variants-metafields"]`,
        ).textContent,
      );
    }
    if (Object.keys(metafields).length > 0) {
      this.currentVariant = {
        ...this.currentVariant,
        metafields: metafields[this.currentVariant.id],
      };
    }
  }

  updateMedia() {
    try {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGalleries = document.querySelectorAll(
        `[id^="MediaGallery-${this.dataset.section}"]`,
      );

      mediaGalleries.forEach((mediaGallery) => {
        const slide = mediaGallery.querySelector(
          `[data-variant-id='${this.currentVariant.featured_media.id}']`,
        );
        if (!slide) return;

        const overlayText =
          this.currentVariant.metafields?.image_overlay_text || "";
        mediaGallery
          .querySelectorAll(".variant-image-overlay")
          .forEach((overlay) => {
            overlay.textContent = "";
            overlay.hidden = true;
          });

        const overlay = slide.querySelector(".variant-image-overlay");
        if (overlay && overlayText) {
          overlay.textContent = overlayText;
          overlay.hidden = false;
        }

        mediaGallery.goToSlide(slide.dataset.slickIndex);
      });

      const activeExtraVariantImages = document.querySelectorAll(
        `.item--variant-extra[data-variant-id="${this.currentVariant.id}"]`,
      );
      const extraVariantImages = document.querySelectorAll(
        `#Thumbnails .item--variant-extra`,
      );

      extraVariantImages.forEach((item) => {
        item.style.display = "none";
      });
      if (activeExtraVariantImages) {
        activeExtraVariantImages.forEach((item) => {
          item.style.display = "block";
        });
      }

      if (typeof goToGallerySlide !== "function") return;
      const gallery = document.getElementById("Gallery");
      if (!gallery) return;
      const galleryItem = gallery.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`,
      );
      if (!galleryItem) return;

      const slide = galleryItem.closest(".gallery-slide, .slick-slide");
      if (!slide) return;

      const overlayText =
        this.currentVariant.metafields?.image_overlay_text || "";
      gallery.querySelectorAll(".variant-image-overlay").forEach((overlay) => {
        overlay.textContent = "";
        overlay.hidden = true;
      });

      const overlay = slide.querySelector(".variant-image-overlay");
      if (overlay && overlayText) {
        overlay.textContent = overlayText;
        overlay.hidden = false;
      }

      const slideIndex = Number(slide.dataset.slickIndex);
      if (Number.isNaN(slideIndex) || slideIndex < 0) return;

      goToGallerySlide(slideIndex);
    } catch (error) {
      console.error(error);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;

    //look for variant param in the url and replace it with the new variant id
    const url = new URL(window.location.href);
    url.searchParams.set("variant", this.currentVariant.id);
    window.history.replaceState({}, "", url);
  }

  updateVariantInput(e) {
    const currentTarget = e.currentTarget;
    const productForm = currentTarget.closest(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-gift-${this.dataset.section}`,
    );
    let input = productForm.querySelector('input[name="id"]');
    let checkoutPropertyKey = productForm.querySelector(
      'input[name="checkout_property"]',
    );
    let checkoutPropertyValue = productForm.querySelector(
      'input[name="checkout_property_value"]',
    );

    if (this.dataset.fieldId !== undefined) {
      input = productForm.querySelector(
        `input[name="${this.dataset.fieldId}"]`,
      );
    }

    if (
      checkoutPropertyKey &&
      checkoutPropertyValue &&
      this.currentVariant.metafields
    ) {
      checkoutPropertyKey.value = this.currentVariant.metafields
        .v2_checkout_property_key
        ? this.currentVariant.metafields.v2_checkout_property_key
        : checkoutPropertyKey.dataset.default;
      checkoutPropertyValue.value = this.currentVariant.metafields
        .v2_checkout_property_value
        ? this.currentVariant.metafields.v2_checkout_property_value
        : checkoutPropertyValue.dataset.default;
    }

    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value"),
        );
      }
    });
  }

  toggleAddButton(disable = true, updateText = false, modifyClass = true) {
    const productForm = this.closest(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #add-to-cart-form`,
    );

    if (!productForm) return;
    const addButton = productForm.querySelector(".btn-add");
    const addButtonText = productForm.querySelector(".btn-add > span");

    if (!addButton) return;

    // Store availability independently of the subscription guard's disabled state.
    if (addButton.dataset.variantAvailable !== undefined) {
      addButton.dataset.variantAvailable = String(!disable);
    }

    const notitySoldOutEl = productForm.querySelector("#nofify_sold-out");
    const isNotifySoldOutEnable =
      this.currentVariant?.metafields?.notify_me_when_available_form === "true"
        ? true
        : false;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (updateText)
        addButtonText.innerHTML = addButton.getAttribute("data-label-sold-out");

      if (notitySoldOutEl) {
        if (isNotifySoldOutEnable) {
          notitySoldOutEl.style.display = "block";
          addButton.style.display = "none";
        } else {
          notitySoldOutEl.style.display = "none";
          addButton.style.display = "block";
        }
      }
    } else {
      addButton.removeAttribute("disabled");
      if (updateText)
        addButtonText.innerHTML = addButton.getAttribute("data-label");

      if (notitySoldOutEl) {
        notitySoldOutEl.style.display = "none";
        addButton.style.display = "block";
      }
    }

    // Variant availability updates must not bypass an existing subscription block.
    productForm.closest("product-form")?.updateOrderQuantityState?.();

    if (!modifyClass) return;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }

  renderProductInfo(currentInput) {
    const labelShade = document.getElementById(
      currentInput.dataset.labelSelected,
    );

    if (labelShade)
      labelShade.innerHTML =
        this.currentVariant[`option${currentInput.dataset.optionPosition}`];

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        variant: this.currentVariant,
      },
      target: this,
    });

    const productForm = this.closest(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #add-to-cart-form`,
    );

    if (productForm.querySelector("selling-plan-selector"))
      productForm.querySelector("selling-plan-selector").style.display =
        currentInput.classList.contains("sold-out") ? "none" : "block";

    const priceEle = productForm?.querySelector(
      `#price-${this.dataset.section}`,
    );

    if (!priceEle) return;

    let price = this.currentVariant.price;
    const sellingPlan = productForm.querySelector("#selling-plan")?.value;
    if (sellingPlan) {
      price = this.currentVariant.selling_plan_allocations[0].price;
    }

    const dataEvent = {
      price: price,
      compareAtPrice:
        this.currentVariant.compare_at_price > this.currentVariant.price
          ? this.currentVariant.compare_at_price
          : null,
      isOnetime: typeof sellingPlan == "undefined" || sellingPlan == "",
    };

    // This is needed for klarna
    dataEvent["sellingPlanAllocation"] =
      this.currentVariant.selling_plan_allocations[0];

    publish(PUB_SUB_EVENTS.onPriceUpdate, {
      data: dataEvent,
      target: productForm.querySelector("product-price"),
    });

    const klarnaContainers =
      productForm.getElementsByTagName("klarna-placement");
    if (
      typeof window.Klarna !== "undefined" &&
      typeof window.Klarna.OnsiteMessaging !== "undefined" &&
      klarnaContainers.length > 0
    ) {
      Array.from(klarnaContainers).forEach((klarnaContainer) => {
        klarnaContainer.setAttribute(
          "data-purchase-amount",
          this.currentVariant.price,
        );
      });

      window.Klarna.OnsiteMessaging.refresh();
    }

    // const labelSize = document.getElementById(`size-${this.dataset.section}`);
    // if (labelSize) labelSize.innerHTML = this.currentVariant.option2;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`,
        );

        if (!activeMedia) return;
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        if (prepend) {
          var old_height = $(document).height(); //store document height before modifications
          var old_scroll = $(window).scrollTop();
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`,
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          $(document).scrollTop(old_scroll + $(document).height() - old_height);
        }

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition,
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img",
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position,
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation"),
        );
      }
    },
  );
}

class CountdownClock extends HTMLElement {
  constructor() {
    super();

    this.hours = this.querySelector(".countdown-clock__hours");
    this.minute = this.querySelector(".countdown-clock__minutes");
    this.second = this.querySelector(".countdown-clock__seconds");

    const now = new Date();
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    this.timestamp = parseInt((end - now) / 1000);
    this.interval = setInterval(this.update.bind(this), 1000);
  }

  update() {
    this.timestamp--;

    if (this.timestamp < 0) {
      clearInterval(this.interval);
    } else {
      let display_hours = Math.floor(this.timestamp / 3600);
      let display_minute = Math.floor((this.timestamp % 3600) / 60);
      let display_seconds = this.timestamp % 60;

      this.hours.innerHTML = `${this.zeroPad(display_hours)}`;
      this.minute.innerHTML = `${this.zeroPad(display_minute)}`;
      this.second.innerHTML = this.zeroPad(display_seconds);
    }
  }

  zeroPad(number) {
    return ("0" + number).slice(-2);
  }

  // update() {
  //   this.timestamp--;

  //   if (this.timestamp < 0) {
  //     clearInterval(this.interval);
  //   } else {
  //     let display_minute = Math.floor(this.timestamp / 60);
  //     let display_seconds = Math.floor(this.timestamp - display_minute * 60);

  //     this.minute.innerHTML = this.zeroPad(display_minute);
  //     this.second.innerHTML = this.zeroPad(display_seconds);
  //   }
  // }
}

customElements.define("countdown-clock", CountdownClock);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min),
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class SpecialOffersVariantRadios extends VariantRadios {
  constructor() {
    super();
    this.currentSelection = this.dataset.defaultSelection;
  }
  async updateVariantInput(e) {
    await updateCart({
      [this.currentVariant.id]: 1,
      [this.currentSelection]: 0,
    });
  }
}

customElements.define("slider-cart-variant-radios", SpecialOffersVariantRadios);

(function () {
  // Yotpo rewards page
  // Set cookie when user clicks on signup link, to later redirect to the same page after signup
  waitForElm(".yotpo-register-link").then((elm) => {
    const button = elm.querySelector("[data-cy='login-register-button']");
    button.addEventListener("click", (e) => {
      document.cookie = `westmore_signup_redirect=${window.location.pathname}; max-age=86400; path=/; domain=${window.location.hostname}`;
    });
  });

  // Check if account page
  // and  setup return_to input to redirect to the page where the user clicked the signup link
  const redirectUrl = getCookie("westmore_signup_redirect");
  if (
    typeof redirectUrl != "undefined" &&
    redirectUrl != null &&
    redirectUrl != "" &&
    (document.querySelector(".create-an-account") ||
      document.querySelector(".login-page"))
  ) {
    const registerForm = document.getElementById("create_customer");
    if (registerForm) {
      const redirectInput = document.createElement("input");
      redirectInput.type = "hidden";
      redirectInput.name = "return_to";
      redirectInput.value = redirectUrl;
      registerForm.appendChild(redirectInput);
    }

    //delete cookie
    document.cookie = `westmore_signup_redirect=; max-age=0; path=/; domain=${window.location.hostname}`;
  }

  window.addEventListener("resize", debounce(onResize, 300));

  function onResize() {
    if (typeof instafeedApp !== "undefined") {
      instafeedApp.call();
    }
  }
})();

(function () {
  if (window.__cartWatcherInitialized) return;
  window.__cartWatcherInitialized = true;

  const isCartMutation = (url = "") =>
    ["/cart/add", "/cart/update", "/cart/change", "/cart/clear"].some((path) =>
      url.includes(path),
    );

  // `url` lets listeners tell an add apart from a quantity change or a clear.
  const emitCartUpdated = (url = "") =>
    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { url } }),
    );

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
    const response = await originalFetch.apply(this, args);
    if (response.ok && isCartMutation(url)) emitCartUpdated(url);
    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._url = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("load", () => {
      if (
        this.status >= 200 &&
        this.status < 300 &&
        isCartMutation(this._url)
      ) {
        emitCartUpdated(this._url);
      }
    });
    return originalSend.apply(this, args);
  };
})();

document.addEventListener("octane.quiz.completed", function (e) {
  const productBlocks = e.detail?.state?.info?.product_blocks || [];
  const unavailableVariantIds = new Set(
    productBlocks.flatMap((productBlock) =>
      Object.values(productBlock.containers || {})
        .filter((container) => container.data?.is_available === false)
        .map((container) => String(container.data.platform_variant_id)),
    ),
  );

  if (!unavailableVariantIds.size) return;

  const variantMetafieldsCache = new Map();
  const getVariantMetafields = (handle) => {
    if (!variantMetafieldsCache.has(handle)) {
      variantMetafieldsCache.set(
        handle,
        fetch(`/products/${handle}?view=metafields`)
          .then((response) => response.json())
          .catch(() => null),
      );
    }
    return variantMetafieldsCache.get(handle);
  };

  const addProductLink = (item, href) => {
    if (item.querySelector(".oct-quiz-product-link, .klaviyo-bis-trigger"))
      return;

    const addToCartButton = item.querySelector(
      ".oct-quiz-result-actions-content button",
    );
    if (!addToCartButton) return;

    addToCartButton.parentElement.style.flexDirection = "column";

    const productLink = document.createElement("a");

    productLink.href = href;
    productLink.target = "_blank";
    productLink.rel = "noopener";
    productLink.className = "oct-quiz-product-link h4";
    productLink.style.width = "100%";
    productLink.style.textDecoration = "underline";
    productLink.style.display = "flex";
    productLink.style.alignItems = "center";
    productLink.textContent = "VIEW PRODUCT";
    productLink.style.justifyContent = "center";
    productLink.style.marginTop = "10px";

    addToCartButton.insertAdjacentElement("afterend", productLink);

    item.querySelector(".oct-quiz-actions-selling-plans-wrapper").hidden = true;
  };

  const addNotifyButton = (item, { handle, productId, variantId }) => {
    if (item.querySelector(".oct-quiz-product-link, .klaviyo-bis-trigger"))
      return;

    const addToCartButton = item.querySelector(
      ".oct-quiz-result-actions-content button",
    );
    if (!addToCartButton) return;

    addToCartButton.hidden = true;

    const variantInputId = `oct-quiz-klaviyo-variant-${variantId}`;
    const variantInput = document.createElement("input");
    const notifyButton = document.createElement("a");

    variantInput.type = "hidden";
    variantInput.id = variantInputId;
    variantInput.value = variantId;

    notifyButton.href = "#";
    notifyButton.className = "klaviyo-bis-trigger btn w-full";
    notifyButton.style.width = "100%";
    notifyButton.style.marginTop = "10px";
    notifyButton.textContent = "Notify Me";
    notifyButton.dataset.klaviyoHandle = handle;
    notifyButton.dataset.klaviyoProductId = productId;
    notifyButton.dataset.klaviyoVariantId = variantId;
    notifyButton.dataset.klaviyoQuickviewVariant = `#${variantInputId}`;
    notifyButton.dataset.productId = productId;
    notifyButton.dataset.variantId = variantId;

    addToCartButton.insertAdjacentElement("afterend", variantInput);
    addToCartButton.insertAdjacentElement("afterend", notifyButton);
  };

  const hideUnavailableProductBlocks = async () => {
    const productItems = document.querySelectorAll(".oct-quiz-products__item");
    const shouldHideUnavailableProducts = productItems.length > 1;

    for (const item of productItems) {
      const href = item.querySelector('a[href*="variant="]')?.href;
      if (!href) continue;

      const url = new URL(href, window.location.origin);
      const variantId = url.searchParams.get("variant");
      if (!variantId || !unavailableVariantIds.has(variantId)) continue;

      if (shouldHideUnavailableProducts) {
        item.hidden = true;
        continue;
      }

      const handle = url.pathname.split("/products/")[1]?.split("/")[0];
      const metafields = handle ? await getVariantMetafields(handle) : null;
      const shouldNotify =
        metafields?.variants_metafields?.[variantId]
          ?.notify_me_when_available_form === true;

      if (shouldNotify) {
        addNotifyButton(item, {
          handle,
          productId: metafields.product_id,
          variantId,
        });
      } else {
        addProductLink(item, href);
      }
    }
  };

  hideUnavailableProductBlocks();

  const observer = new MutationObserver(hideUnavailableProductBlocks);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 5000);
});

// The header cart count is re-rendered by the `cart:updated` listener in
// cart.js, which handles the empty-cart case this could not.
